import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from 'jquery'
import { auto } from '@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core';
import NumericCellDinamic from './NumericTextDinamic';
import DropDownCellCapacidades from './myDropDownCellCapacidades';
// export const DropDownCellProduto = props => {
  
var optionsCapacidades = [];
var DropDownCellTipoVasilha = null;

var IdCorrelativas = null;

class DropDownCellCorrelativa extends Component {
  
  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });

    IdCorrelativas = e;    
    console.log(this.props.field)
    
    $('#id-Correlativa-Capacidade').html(e.value.value);

    if(this.props.field == "CorrelativaND"){
      DropDownCellCapacidades.changebyCorrelativa(e.value.text , this.props.dataItem)
    }
  }

  static ChangeValueById(id){

    console.log('DropDownCellCorrelativaDropDownCellCorrelativaDropDownCellCorrelativaDropDownCellCorrelativaDropDownCellCorrelativa')
    optionsCapacidades = [];
    (async () => {
      if(id.value.value != undefined){
        var valor = id.value.value
      }else{
        var valor = id.value
      }
        const data = {"IDRegistoProduto" : valor}
        const Correlativa = await services.apiCall.requestApi(
          "/Rotulos/GetCorrelativas",
          data,
          "get"
        );

        if(Correlativa){
          Correlativa.map((Correlativa) => (
            optionsCapacidades.push({text: Correlativa.correlativa, value: Correlativa.valor, idRotulo: Correlativa.idRotulo})
          ));     
        }else{
          optionsCapacidades = [];
        };        
    })();

  }

  componentDidMount = () => {

    // myFunction();

  }

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    return (
      field == "Correlativa_rotulos" ? 
        <td>
            {dataItem.inEdit ?
            <DropDownList
                popupSettings={{
                  width: 'max-content',
                }}
                onChange={this.handleChange}
                value={optionsCapacidades.length > 0 ? optionsCapacidades.find(c => c.value === (dataValue != null ? dataValue.idRotulo != null ? dataValue.idRotulo :dataValue : null)): dataItem.Correlativa_rotulos}
                data={optionsCapacidades}
                textField="text"
                id='id-DropDownCellCapacidades'
            />
            : dataValue != null ? dataValue.text.toString() : undefined}
        </td>
        : 
        <td>
        {dataItem.inEdit ?
        <DropDownList
            popupSettings={{
              width: 'max-content',
            }}
            onChange={this.handleChange}
            value={optionsCapacidades.length > 0 ? optionsCapacidades.find(c => c.value === (dataValue != null ? dataValue.idRotulo != null ? dataValue.idRotulo :dataValue : null)): dataItem.Correlativa}
            data={optionsCapacidades}
            textField="text"
            id='id-DropDownCellCapacidades'
        />
        : dataValue != null ? dataValue.text.toString() : undefined}
    </td>
    );
  }
}

export default DropDownCellCorrelativa;